import { computed, inject, Pipe, PipeTransform } from '@angular/core';
import {
  CurrencySymbol,
  isCurrencySymbolFirst
} from '../helpers/client.utils';
import { LanguageStore } from '../services/language.store';
import { ProjectStateService } from '../services/state/project-state.service';

@Pipe({
  name: 'currencyFormat',
  standalone: true,
  pure: false
})
export class CurrencyFormatPipe implements PipeTransform {
  readonly #languageStore: LanguageStore = inject(LanguageStore);
  readonly projectStateService: ProjectStateService =
    inject(ProjectStateService);

  public transform(value: string | number): string {
    return computed(() => {
      const currency =
        this.projectStateService.getPricingInformations()?.currency;
      const language = this.#languageStore.currentLanguageCode();
      const symbol =
        currency === 'expat_eur' || currency === 'expat_cfe'
          ? CurrencySymbol.EURO
          : CurrencySymbol.DOLLAR;
      const symbolFirst = isCurrencySymbolFirst(symbol, language);

      if (!value) {
        return symbolFirst ? symbol + '--' : '--' + symbol;
      }

      const numberValue = typeof value === 'string' ? parseFloat(value) : value;
      const amount = new Intl.NumberFormat(
        language === 'fr' ? 'fr-FR' : 'en-US',
        {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2
        }
      ).format(numberValue);

      return symbolFirst ? symbol + amount : amount + symbol;
    })();
  }
}
